module.exports = __webpack_public_path__ + "img/Picture81.93376973.jpg";